import { jsxs, jsx } from "react/jsx-runtime";
const IconDocumentSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "m15.5 4.7-3.6-3.2L10.7.3c-.2-.2-.4-.3-.7-.3H1.8C.8 0 0 1.1 0 2.5V18c-.1 1 .7 1.9 1.7 2H14c1 .1 1.9-.7 2-1.7V6c0-.5-.2-1-.5-1.3ZM11 3.4 12.6 5H11V3.4ZM3 18c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1h6v4c0 .6.4 1 1 1h4v10c0 .6-.4 1-1 1H3Z" }),
      /* @__PURE__ */ jsx("path", { d: "M10 9H5c-.6 0-1 .4-1 1s.4 1 1 1h5c.6 0 1-.4 1-1s-.4-1-1-1Zm-2 4H5c-.6 0-1 .4-1 1s.4 1 1 1h3c.6 0 1-.4 1-1s-.4-1-1-1Z" })
    ]
  }
);
export {
  IconDocumentSvg
};
